export default {"src":"/_next/static/media/mochi-coin-circle.3e9a9e71.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};